import type { CSSProperties } from 'react';
import { Checkbox } from '../../components/general/Checkbox';
import { Text } from '../../components/general/Text';
import { getServerNameCode } from '../../config/gcs/gcsConfigs';

interface GcsServerCheckboxTileProps {
  id: string;
  name: string;
  isSelected: boolean;
  onToggle: (id: string) => void;
}

const serverOptionStyle = (isSelected: boolean): CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '12px',
  border: `var(--card-border-stroke) var(--card-border-style) ${isSelected ? 'var(--brand-primary)' : '#E3E3E3'}`,
  borderRadius: 'var(--card-border-radius)',
  cursor: 'pointer',
  backgroundColor: '#fff',
  transition: 'background-color 0.2s ease'
});

const serverInfoStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px',
  flex: 1,
  textAlign: 'left'
};

export const GcsServerCheckboxTile = ({ id, name, isSelected, onToggle }: GcsServerCheckboxTileProps) => {
  const nameCode = getServerNameCode(id);

  return (
    <div
      style={serverOptionStyle(isSelected)}
      onClick={() => onToggle(id)}
      role='checkbox'
      aria-checked={isSelected}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          onToggle(id);
        }
      }}
    >
      <Checkbox checked={isSelected} onChange={() => onToggle(id)} />
      <div style={serverInfoStyle}>
        <Text variant='body2'>{nameCode}</Text>
        <Text variant='body2'>{name}</Text>
      </div>
    </div>
  );
};
